import PropTypes from 'prop-types';
import React from 'react';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { bindAll } from '@bibliocommons/utils-react';
import LibraryNotice from 'app/components/shared/LibraryNotice';
import BatchActionsControls from '../BatchActionsControls';
import BatchActionsToolbar from '../BatchActionsToolbar';

import './BatchActionsList.scss';

export default class BatchActionsList extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedItems: Immutable.Map(),
      list: null
    };

    bindAll(this);
  }

  static getDerivedStateFromProps(props, state) {
    const list = props.list;
    if (props.list.equals(state.list)) {
      const selectedItems = Immutable.Map().withMutations(updatedSelectedItems => {
        state.selectedItems.forEach(selectedItem => {
          const updatedItem = list.find(item => selectedItem.get('id') === item.get('id'));
          if (updatedItem) {
            updatedSelectedItems.set(updatedItem.get('id'), updatedItem);
          }
        });
      });
      return { selectedItems, list };
    }
    return { list };
  }

  updateAll(selected) {
    if (selected) {
      this.setState({
        selectedItems: this.props.list.reduce((result, item) => result.set(item.get('id'), item), Immutable.Map())
      });
    } else {
      this.setState({
        selectedItems: Immutable.Map()
      });
    }
  }

  updateItem(item) {
    if (typeof item.get('id') === 'undefined') {
      throw new Error('[BatchActionsList] updateItem must be called with an Immutable.Map with an `id`', item);
    }

    const isSelected = this.state.selectedItems.has(item.get('id'));
    if (isSelected) {
      return this.setState(state => ({
        selectedItems: state.selectedItems.deleteIn([item.get('id')])
      }));
    }

    return this.setState(state => ({
      selectedItems: state.selectedItems.set(item.get('id'), item)
    }));
  }

  renderBatchActionControls() {
    const { renderAdditionalControls } = this.props;
    return (
      <BatchActionsControls list={this.props.list} selectedItems={this.state.selectedItems} updateAll={this.updateAll}>
        {renderAdditionalControls ? renderAdditionalControls() : null}
      </BatchActionsControls>
    );
  }

  renderBatchActionsToolbar() {
    return (
      <BatchActionsToolbar
        actionIsLoading={this.props.actionIsLoading}
        handleClear={() => this.updateAll(false)}
        renderActionsMenu={this.props.renderActionsMenu}
        totalItems={this.props.totalItems}
        globalMessaging={this.props.globalMessaging}
        messagingActions={this.props.messagingActions}
        selectedItems={this.state.selectedItems}
        renderAdditionalButtons={this.props.renderAdditionalButtons}
      />
    );
  }

  render() {
    return (
      <div className="cp-batch-actions-list">
        {this.props.noticeId && <LibraryNotice id={this.props.noticeId} className="batch-actions-notice" />}
        {this.renderBatchActionControls()}
        {this.props.children(this.state.selectedItems, this.updateItem)}
        {this.renderBatchActionsToolbar()}
      </div>
    );
  }
}

BatchActionsList.propTypes = {
  actionIsLoading: PropTypes.bool,
  list: ImmutablePropTypes.list.isRequired,
  totalItems: PropTypes.number.isRequired,
  renderActionsMenu: PropTypes.func.isRequired,
  renderAdditionalControls: PropTypes.func,
  renderAdditionalButtons: PropTypes.func,
  globalMessaging: ImmutablePropTypes.map,
  children: PropTypes.func.isRequired,
  messagingActions: PropTypes.objectOf(PropTypes.func).isRequired,
  noticeId: PropTypes.string
};
